export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const YEAR_IN_SECONDS = 31449600;
export const EXPIRATION_THRESHOLD = 60 * 60 * 24 * 30;
